import { Helmet } from 'react-helmet-async';
import { useContext } from 'react';
import { TranslationsContext } from '../../../context/TranslationsContext';

export const TermsOfUseHelmet = () => {
  const { fullTranslations, mainLang } = useContext(TranslationsContext);
  return (
    <Helmet htmlAttributes={{ lang: mainLang, amp: undefined }}>
      <title>{fullTranslations?.head?.termsOfUse?.title}</title>
      <meta
        name="description"
        content={fullTranslations?.head?.termsOfUse?.description}
      />
      <meta property="og:image" content="https://www.mykin.in/preview.png" />
      <meta property="og:image:width" content="663" />
      <meta property="og:image:height" content="649" />
      <meta
        property="og:title"
        content={fullTranslations?.head?.termsOfUse?.title}
      />
      <meta
        property="og:description"
        content={fullTranslations?.head?.termsOfUse?.ogDescription}
      />
      <meta property="og:url" content="https://www.mykin.in/ua" />
      <meta name="twitter:image" content="https://www.mykin.in/preview.png" />
      <meta
        name="twitter:title"
        content={fullTranslations?.head?.termsOfUse?.title}
      />
      <meta
        name="twitter:description"
        content={fullTranslations?.head?.termsOfUse?.ogDescription}
      />
      <meta property="vk:url" content="https://www.mykin.in/ua" />

      <meta property="vk:image" content="https://www.mykin.in/preview.png" />
      <meta
        property="vk:title"
        content={fullTranslations?.head?.termsOfUse?.title}
      />
      <meta
        property="vk:description"
        content={fullTranslations?.head?.termsOfUse?.ogDescription}
      />
    </Helmet>
  );
};
